// src/hooks/useLanguages.js
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setLanguages } from "../Redux/languageSlice";
import { fetchLanguages } from "../utils/fetcher";

export function useLanguages() {
  const dispatch = useDispatch();
  const { languages, isLoaded } = useSelector((state) => state.languages);
  const [langLoading, setLangLoading] = useState(false);
  const [supportedLanguages, setSupportedLanguages] = useState(['en','hi','ta']);
  

  useEffect(() => {
    if (!isLoaded) {
      setLangLoading(true);
      fetchLanguages()
        .then((data) => {
          dispatch(setLanguages(data));
          setLangLoading(false);
        })
        .catch(() => setLangLoading(false));
    }
  }, [isLoaded, dispatch]);

  // Optionally, you can add helpers, e.g., findLanguageByCode
  const findLanguageByCode = (code) =>
    languages.find((lang) => lang.code === code);

  return { languages, langLoading, findLanguageByCode,supportedLanguages };
}
